import { c as _c } from "react/compiler-runtime";
import type { ApiProfileRepCategorySummary } from "@/generated/models/ApiProfileRepCategorySummary";
import { formatNumberWithCommas } from "@/helpers/Helpers";
type IdentityProfileSupplementProfile = {
  readonly bio?: string | null | undefined;
  readonly top_rep_categories?: readonly ApiProfileRepCategorySummary[] | null | undefined;
};
type IdentityProfileSupplementVariant = "default" | "chat" | "compact";
interface IdentityProfileSupplementProps {
  readonly profile: IdentityProfileSupplementProfile;
  readonly variant: IdentityProfileSupplementVariant;
  readonly maxRepCategories?: number | undefined;
}
const normalizeBio = (bio: string | null | undefined): string | null => {
  const trimmedBio = bio?.trim();
  return trimmedBio && trimmedBio.length > 0 ? trimmedBio : null;
};
const getRepCategories = (categories: readonly ApiProfileRepCategorySummary[] | null | undefined): ApiProfileRepCategorySummary[] => (categories ?? []).filter(category => category.category.trim().length > 0);
const formatSignedRep = (rep: number): string => {
  const formattedValue = formatNumberWithCommas(Math.abs(rep));
  if (rep > 0) {
    return `+${formattedValue}`;
  }
  if (rep < 0) {
    return `-${formattedValue}`;
  }
  return formattedValue;
};
export default function IdentityProfileSupplement(t0) {
  const $ = _c(15);
  const {
    profile,
    variant,
    maxRepCategories
  } = t0;
  let t1;
  if ($[0] !== profile.bio) {
    t1 = normalizeBio(profile.bio);
    $[0] = profile.bio;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const bio = t1;
  let t2;
  let t3;
  let t4;
  if ($[2] !== bio || $[3] !== maxRepCategories || $[4] !== profile.top_rep_categories || $[5] !== variant) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const repCategories = getRepCategories(profile.top_rep_categories);
      const visibleRepCategories = maxRepCategories === undefined ? repCategories : repCategories.slice(0, maxRepCategories);
      if (!bio && visibleRepCategories.length === 0) {
        t4 = null;
        break bb0;
      }
      if ($[9] !== bio || $[10] !== variant) {
        t2 = bio && <p className={`tw-mb-3 tw-line-clamp-2 tw-whitespace-pre-line tw-break-words tw-leading-relaxed tw-text-iron-300 ${variant === "default" ? "tw-text-sm tw-font-medium tw-leading-6" : "tw-text-[13px] tw-font-medium tw-leading-5"}`}>{bio}</p>;
        $[9] = bio;
        $[10] = variant;
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      t3 = visibleRepCategories.length > 0 && <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-1.5">{visibleRepCategories.map(_temp)}</div>;
    }
    $[2] = bio;
    $[3] = maxRepCategories;
    $[4] = profile.top_rep_categories;
    $[5] = variant;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3) {
    t5 = <div>{t2}{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp(category) {
  return <span key={`${category.category}-${category.rep}`} className="tw-inline-flex tw-items-center tw-gap-x-1 tw-rounded-lg tw-bg-black/50 tw-px-2 tw-py-1.5 tw-text-[10px] tw-font-medium tw-uppercase tw-leading-4 tw-tracking-widest tw-text-iron-200 tw-shadow-inner"><span> {category.category}</span><span className="tw-text-iron-400">{formatSignedRep(category.rep)}</span></span>;
}